import { render, staticRenderFns } from "./write.vue?vue&type=template&id=4051b0e6&scoped=true"
import script from "./write.vue?vue&type=script&lang=js"
export * from "./write.vue?vue&type=script&lang=js"
import style0 from "./write.vue?vue&type=style&index=0&id=4051b0e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4051b0e6",
  null
  
)

export default component.exports